<template>
  <nav class="navbar wrapper navbar-light navbar-expand p-0">
    <ul class="navbar-nav">
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title1') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('merch-vectors'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Graphics Index Menu',
                  $trailingSlash(localePath('merch-vectors'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option1') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('free-vectors'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Graphics Index Menu',
                  $trailingSlash(localePath('free-vectors'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option2') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('svg-png'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent('Click Button Graphics Index Menu', $trailingSlash(localePath('svg-png')))
              "
            >
              {{ $t('main.header.menuOptions.option3') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'psd',
                  keyword: 'mockup'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Graphics Index Menu',
                  $urlBuilder('search', {
                    path: 'psd',
                    keyword: 'mockup'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option4') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('merch-psd'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent('Click Button Graphics Index Menu', $trailingSlash(localePath('merch-psd')))
              "
            >
              {{ $t('main.header.menuOptions.option5') }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title2') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('niches'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent('Click Button Browse by Index Menu', $trailingSlash(localePath('niches')))
              "
            >
              {{ $t('main.header.menuOptions.option6') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('topics'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent('Click Button Browse by Index Menu', $trailingSlash(localePath('topics')))
              "
            >
              {{ $t('main.header.menuOptions.option7') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('styles'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent('Click Button Browse by Index Menu', $trailingSlash(localePath('styles')))
              "
            >
              {{ $t('main.header.menuOptions.option8') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('collections'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Browse by Index Menu',
                  $trailingSlash(localePath('collections'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option9') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('categories'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Browse by Index Menu',
                  $trailingSlash(localePath('categories'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option10') }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title3') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-vectors',
                  keyword: 't-shirt'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-vectors',
                    keyword: 't-shirt'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option11') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-psd',
                  keyword: 't-shirt'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-psd',
                    keyword: 't-shirt'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option12') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-vectors',
                  keyword: 'book-cover-design'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-vectors',
                    keyword: 'book-cover-design'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option13') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-vectors',
                  keyword: 'tote-bag'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-vectors',
                    keyword: 'tote-bag'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option14') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-vectors',
                  keyword: 'phone-case'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-vectors',
                    keyword: 'phone-case'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option15') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-vectors',
                  keyword: 'popsockets'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-vectors',
                    keyword: 'popsockets'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option16') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'merch-vectors',
                  keyword: 'throw-pillow'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'merch-vectors',
                    keyword: 'throw-pillow'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option17') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'free-vectors',
                  keyword: 'poster'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'free-vectors',
                    keyword: 'poster'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option18') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'free-vectors',
                  keyword: 'logos'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'free-vectors',
                    keyword: 'logos'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option19') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $urlBuilder('search', {
                  path: 'free-vectors',
                  keyword: 'business-card'
                })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('search', {
                    path: 'free-vectors',
                    keyword: 'business-card'
                  })
                )
              "
            >
              {{ $t('main.header.menuOptions.option20') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$urlBuilder('landing', { uid: 'presentation-templates' })"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Products by Index Menu',
                  $urlBuilder('landing', { uid: 'presentation-templates' })
                )
              "
            >
              {{ $t('main.header.menuOptions.option21') }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title4') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <a
              href="https://mockups.vexels.com/"
              rel="noopener noreferrer"
              target="_blank"
              class="dropdown-item"
              @click="$ga.event('Index Menu', 'Click Button Tools Index Menu', $route.fullPath)"
            >
              {{ $t('main.header.menuOptions.option22') }}
            </a>
          </li>
          <li class="nav-dropdow-item">
            <a
              href="https://www.vexels.com/t-shirt-maker/"
              target="_blank"
              class="dropdown-item"
              rel="noopener noreferrer"
              @click="$ga.event('Index Menu', 'Click Button Tools Index Menu', $route.fullPath)"
            >
              {{ $t('main.header.menuOptions.option23') }}
            </a>
          </li>
          <li class="nav-dropdow-item">
            <a
              href="https://logomaker.vexels.com/"
              target="_blank"
              class="dropdown-item"
              rel="noopener noreferrer"
              @click="$ga.event('Index Menu', 'Click Button Tools Index Menu', $route.fullPath)"
            >
              {{ $t('main.header.menuOptions.option24') }}
            </a>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="requestLink"
              class="dropdown-item"
              event=""
              @click.native="gaEvent('Click Button Tools by Index Menu', requestLink)"
            >
              {{ $t('main.header.menuOptions.option25') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="
                $auth.loggedIn
                  ? $trailingSlash(localePath('profile-tools-merch-digest'))
                  : $urlBuilder('landing', { uid: 'merch-digest' })
              "
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Tools by Index Menu',
                  $auth.loggedIn
                    ? $trailingSlash(localePath('profile-tools-merch-digest'))
                    : $urlBuilder('landing', { uid: 'merch-digest' })
                )
              "
            >
              {{ $t('main.header.menuOptions.option26') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <a
              href="https://www.vexels.com/blog/"
              target="_blank"
              class="dropdown-item"
              rel="noopener noreferrer"
              @click="$ga.event('Index Menu', `Click Button Tools Index Menu`, $route.fullPath)"
            >
              {{ $t('main.header.menuOptions.option27') }}
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title5') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('merch-latest-designs'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Latest Merch Index Menu',
                  $trailingSlash(localePath('merch-latest-designs'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option28') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('our-graphics'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Latest Index Menu',
                  $trailingSlash(localePath('our-graphics'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option29') }}
            </nuxt-link>
            <nuxt-link
              :to="$trailingSlash(localePath('design-latest-vectors'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Latest Design Index Menu',
                  $trailingSlash(localePath('design-latest-vectors'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option30') }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title6') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('merch-trending-designs'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Trending Merch Index Menu',
                  $trailingSlash(localePath('merch-trending-designs'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option31') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('trending-vectors'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Trending Index Menu',
                  $trailingSlash(localePath('trending-vectors'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option32') }}
            </nuxt-link>
            <nuxt-link
              :to="$trailingSlash(localePath('design-trending-graphics'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Trending Design Index Menu',
                  $trailingSlash(localePath('design-trending-graphics'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option33') }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="nav-bar-options nav-item b-nav-dropdown dropdown option-item">
        <button class="nav-link dropdown-toggle vx-dropdown">
          <span>{{ $t('main.header.menuOptions.title7') }}</span>
        </button>
        <ul class="dropdown-menu">
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('merch-featured-designs'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Featured Design Index Menu',
                  $trailingSlash(localePath('merch-featured-designs'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option34') }}
            </nuxt-link>
          </li>
          <li class="nav-dropdow-item">
            <nuxt-link
              :to="$trailingSlash(localePath('featured-vectors'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Featured Index Menu',
                  $trailingSlash(localePath('featured-vectors'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option35') }}
            </nuxt-link>
            <nuxt-link
              :to="$trailingSlash(localePath('design-featured-graphics'))"
              class="dropdown-item"
              event=""
              @click.native="
                gaEvent(
                  'Click Button Featured Design Index Menu',
                  $trailingSlash(localePath('design-featured-graphics'))
                )
              "
            >
              {{ $t('main.header.menuOptions.option36') }}
            </nuxt-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  computed: {
    requestLink() {
      const link = this.$auth.loggedIn
        ? this.localePath('profile-my-requests-new')
        : this.$urlBuilder('landing', { uid: 'design-requests' });
      return link;
    }
  },
  methods: {
    gaEvent(action, url) {
      this.$ga.event('Index Menu', action, this.$route.fullPath);
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.vx-dropdown {
  background: none;
  border: none;
  outline: none;
}
.dropdown-menu {
  font-size: 13px !important;
}
.dropdown:hover .dropdown-menu {
  display: block;
}
.dropdown-menu:hover {
  display: block;
}
.dropdown-menu::before {
  content: '';
  position: absolute;
  top: -10px;
  height: 10px;
  width: 100%;
}
.nav-bar-options {
  padding: 0 10px 0 0;
  @include md {
    padding: 0 10px 0 0 !important;
  }
}
.navbar-light .navbar-nav .nav-link {
  color: $white;
}
.option-item {
  font-size: 13px;
  @include xl {
    font-size: 11px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  margin-left: 10px;
  margin-right: 10px;
  @include xl {
    margin-left: 2px;
    margin-right: 2px;
  }
}
</style>

<style lang="scss">
.dropdown-toggle::after {
  color: $white;
  top: 1px;
  position: relative;
}
.nav-dropdow-item > a {
  color: $white;
  @include xl {
    font-size: 13px !important;
  }
}
.option-item > a > span {
  color: $white;
  margin-right: 5px;
}
.option-item > ul {
  margin-top: 10px;
  background-color: #545454;
  transition: tabindex 0.3s;
}
</style>
